import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getSportsAsAString } from "../../utlilites";
import {
  Directions,
  spotConstants,
  translationConstants,
} from "../../../../../constants";
import WindyMapView from "../../../../../shared/WindyMap/WindyMapView";
import SpotAttribute from "../../../../../shared/components/PublicSpot/SpotAttribute";
import {
  CashIcon,
  SportsIcon,
  LocationIcon,
  DirectionIcon,
  WindSeasonIcon,
  WindSensorIcon,
  WindDirectionIcon,
} from "../../../../../assets/images/icon";

function SpotDetails(props) {
  const { t } = useTranslation();
  const { spotInfo } = props.spotDetail;
  const { sportIds } = props.spotDetail;

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  return (
    <>
      <section className="col-9 mt-4 mt-md-0">
        <section className="d-block d-lg-flex d-md-flex justify-content-between">
          <SpotAttribute
            className={"col-12 col-md-4 col-lg-4 my-3"}
            icon={LocationIcon}
            heading={t(translationConstants.LOCATION)}
            label={
              direction == Directions.rtl && spotInfo?.arabicLocationName
                ? spotInfo?.arabicLocationName
                : spotInfo?.locationName
            }
            leftToRight={!spotInfo?.arabicLocationName}
          />
          <div className="col-12 col-md-4 col-lg-4 my-3 d-none d-md-block">
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${spotInfo?.lat},${spotInfo?.long}`}
              target="_blank"
              className="font-14 center-card-view-detail-link "
            >
              <img src={DirectionIcon} alt="get directions icon" />
              {t(translationConstants.GET_DIRECTIONS)}
            </a>
          </div>
        </section>
        <section className="d-block d-lg-flex d-md-flex">
          {spotInfo?.windSeason && (
            <SpotAttribute
              className={"col-12 col-md-4 col-lg-4 my-3"}
              icon={WindSeasonIcon}
              heading={t(translationConstants.WIND_SEASON)}
              label={
                direction == Directions.rtl && spotInfo?.arabicWindSeason
                  ? spotInfo?.arabicWindSeason
                  : spotInfo?.windSeason
              }
            />
          )}
          {spotInfo?.nearWindSensorURL && (
            <SpotAttribute
              className={"col-12 col-md-4 col-lg-4 my-3"}
              icon={WindSensorIcon}
              heading={t(translationConstants.WIND_SENSOR_LINK)}
              label={spotInfo?.nearWindSensorURL}
            />
          )}
          <SpotAttribute
            className={"col-12 col-md-4 col-lg-4 my-3"}
            icon={WindDirectionIcon}
            heading={t(translationConstants.WIND_DIRECTION)}
            label={spotInfo?.usualWindDrection}
          />
        </section>
        <section className="d-block d-lg-flex d-md-flex">
          <SpotAttribute
            className={"col-12 col-md-4 col-lg-4 my-3"}
            icon={SportsIcon}
            heading={t(translationConstants.SUITABLE_SPORTS)}
            label={getSportsAsAString(t, sportIds)?.split(",").join("\n\n")}
          />
          <SpotAttribute
            className={"col-12 col-md-4 col-lg-4 my-3"}
            icon={WindDirectionIcon}
            heading={t(translationConstants.PREFERRED_WIND_DIRECTION)}
            label={spotInfo?.preferredWindDrection}
          />
        </section>
        {spotInfo?.entryFee &&
          spotInfo?.spotTypeId === spotConstants.spotType.PRIVATE && (
            <section className="d-block d-lg-flex d-md-flex">
              <SpotAttribute
                className={"col-12 col-md-4 col-lg-4 my-3"}
                icon={CashIcon}
                heading={t(translationConstants.ENTRY_FEES)}
                label={`${translationConstants.SAR} ${spotInfo?.entryFee}`}
              />
            </section>
          )}
      </section>
      <div className="mb-3">
        <WindyMapView lat={spotInfo?.lat} long={spotInfo?.long} />
      </div>
    </>
  );
}

export default SpotDetails;
